<template>
    <div class="favorites-container">
        <h3>Mine favoritter</h3>
        <div class="product-grid-container">
            <div v-for="product in products"
                :key="product.id"
                class="prod-card-container">

                <div class="prod-card-content">
                    <img src="https://etakeawaydemoblobs.blob.core.windows.net/fujisushidrammenas/6605793e-a09f-4879-b9e3-08d64b1bfb7e" />
                    <div class="prod-card-info">
                        <div class="prod-card-name">{{ product.name }}</div>
                            <div class="prod-card-price">
                                <div class="prod-card-price-position">149,—</div>
                                <div class="prod-card-icons">
                                    <div class="card-icon plus">
                                        <a>
                                            <a-icon type="plus" />
                                            <span class="icon-plus">
                                                Add to cart
                                                <a-icon class="prod-icon-more" type="more" />
                                            </span>
                                        </a>
                                    </div>
  
                                    <div class="card-icon">
                                        <a>
                                            <a-icon type="info" />
                                                <span>
                                                    Customize/Details
                                                    <a-icon class="prod-icon-more" type="more" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
</template>
  
<script>
export default {
    data() {
        return {
            products: [
                { id: 1, name: "Fuji Mini", price: "149,—" },
                { id: 2, name: "Fuji Mini", price: "149,—" },
                { id: 3, name: "Fuji Mini", price: "149,—" },
                { id: 4, name: "Fuji Mini", price: "149,—" },
                { id: 5, name: "Fuji Mini", price: "149,—" },
                { id: 6, name: "Fuji Mini", price: "149,—" },
                { id: 7, name: "Fuji Mini", price: "149,—" }
            ]
        };
    },
    methods: {

    }
    };
</script>

<style lang="scss">
  $desktop: 1200px;
  $laptop: 1024px;
  $tablet: 768px;
  $mobile: 480px;
  .favorites-container {
    width: 100%;
    margin-right: 2rem;
  }
  .product-grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(219px, 1fr));
    grid-gap: 51px;
  }
  .prod-card-container {
    height: 100%;
    width: 250px;
    font-family: Bebas;
  }
  .prod-card-content {
    background-color: #f5f5f5;
    box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.82);
    height: auto;
    width: auto;
    margin-bottom: 1rem;
    border-radius: 37px;
  
    & img {
      border-radius: 37px;
    }
  }
  
  .prod-icon-more svg {
    margin-right: -8px !important;
    bottom: 19px !important;
  }
  
  .prod-card-icons .card-icon {
    padding: 0px;
    width: auto;
    border: 2px solid;
    border-radius: 50px;
    overflow: hidden;
    float: right;
    margin: 3px;
    &:hover {
      cursor: pointer;
    }
  }
  
  .prod-card-icons .card-icon a {
    position: relative;
    display: block;
    min-width: 27px;
    padding: 5px 13px 5px 10px;
  }
  .prod-card-icons .card-icon .anticon svg {
    background-image: linear-gradient(
      to right,
      rgba(245, 245, 245, 0) 0%,
      rgba(245, 245, 245, 5) 33%,
      rgba(245, 245, 245, 1) 33%
    );
    box-sizing: border-box;
  
    position: relative;
    margin: -20px;
    text-decoration: none;
    color: black; /*Color of the Icon*/
    position: absolute;
  
    right: 24px;
    bottom: 24px;
  
    font-size: 22px !important;
    text-align: center;
    line-height: 28px !important;
  }
  .prod-card-icons span {
    position: relative;
  
    white-space: nowrap;
    margin-right: 0px;
    display: inline-block;
    vertical-align: top;
    position: relative;
    visibility: none;
    width: auto;
    max-width: 0px;
    opacity: 0;
    text-align: center;
    text-transform: uppercase;
    transition: all 1s;
    box-sizing: border-box;
    padding-right: 0px;
    text-decoration: none;
    color: black;
  }
  
  .card-icon span {
    text-align: center;
    padding-right: 8px;
  }
  
  .card-icon:hover .icon-plus {
    margin-right: 0px;
    opacity: 1;
    width: auto;
    max-width: 500px; /* this value makes the transition */
    padding: 0 38px 0 10px;
  }
  
  @media (max-width: $mobile) {
    .plus span {
      margin-right: 0px;
      opacity: 1;
      width: auto;
      max-width: 500px; /* this value makes the transition */
      padding: 0 38px 0 10px;
    }
  }
  .prod-card-icons {
    padding-right: 9px;
    display: flex;
  }
  
  /*Dette er i-element, altså anticon svg */
  .prod-card-icons .anticon svg {
  }
  
  .prod-card-price-position {
    margin-top: 12px;
    font-weight: 700;
    font-size: 20px;
  }
  
  .prod-card-name {
    margin: 10px 0 30px 10px;
    font-size: 20px;
  }
  
  .card-image {
    height: auto;
    width: auto;
  }
  
  .prod-card-price {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    margin-left: 10px;
    padding-bottom: 10px;
  }
  </style>
  